import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Construction, Sparkles } from "lucide-react";

export function ModuleComingSoon({ title, subtitle, icon, features = [] }) {
  return (
    <div>
      <PageHeader
        title={title}
        subtitle={subtitle}
        icon={icon}
        actions={<Badge variant="outline" className="gap-1.5 border-amber-500/40 bg-amber-500/10 text-amber-600"><Construction className="h-3.5 w-3.5" /> Modulo in configurazione</Badge>}
      />
      <Card className="flex flex-col items-center justify-center gap-4 rounded-xl border-dashed p-12 text-center" data-testid="coming-soon-card">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          <Sparkles className="h-8 w-8" />
        </div>
        <div className="max-w-md">
          <h3 className="font-heading text-xl font-semibold">In arrivo nella prossima fase</h3>
          <p className="mt-2 text-sm text-muted-foreground">
            Questo modulo è già predisposto nell'architettura di Connectivity e sarà attivato
            con l'integrazione Meta WhatsApp Cloud API.
          </p>
        </div>
        {features.length > 0 && (
          <div className="mt-2 flex flex-wrap justify-center gap-2">
            {features.map((f) => (
              <Badge key={f} variant="secondary" className="font-normal">{f}</Badge>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
